import React, { useContext, useEffect, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const MonitorProgramDropdown = ({
  selectedProgram,
  setSelectedProgram,
}) => {
  const { DBObject, uuid, setCloseModal, t } = useContext(TMDataContext);

  const dropdownList = DBObject.MonitorPrograms.map((program) => {
    return (
      <option key={uuid()} value={program.id} id={program.id}>
        {program.name}
      </option>
    );
  });

  const handleClick = (element) => {
    var monitorProgram = DBObject.MonitorPrograms.find(
      (program) => program.id == element.currentTarget.value
    );
    setSelectedProgram(monitorProgram);
  };

  return (
    <select
      className="goal-category-dropdown"
      name="monitor-programs"
      value={selectedProgram ? selectedProgram.id : ""}
      onChange={(e) => {
        handleClick(e);
      }}
      id="monitor-reload-dropdown"
    >
      <option disabled value="">
        {t("buttons.select_program")}
      </option>
      {dropdownList}
    </select>
  );
};
